module.exports = __webpack_public_path__ + "img/school.2726b1b8.svg";